var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('userHead',{attrs:{"userInfo":_vm.userInfo,"usertype":_vm.usertype}}),_c('userOrder',{attrs:{"orderlistPath":"/orderlistEn/0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }